// t = current time
// b = start value
// c = change in value
// d = duration
const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

export default function scrollTo(to = 0, duration = 400) {
    let start = getBodyElement().scrollTop,
        change = to - start,
        currentTime = 0,
        timeOffset: number;
    const animateScroll = (timestamp: number) => {
        if (!timeOffset) timeOffset = timestamp;
        currentTime = timestamp - timeOffset;
        let val = easeInOutQuad(currentTime, start, change, duration);
        getBodyElement().scrollTop = val;
        if (currentTime < duration) {
            window.requestAnimFrame(animateScroll);
        }
    };
    window.requestAnimFrame(animateScroll);
}

export const getBodyElement = () => {
    const el = document.scrollingElement || document.documentElement;
    return el;
};
